<template>
  <div>

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5>
            <p class="table_card__head--title">Mensajes de Whatsapp</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                class="breadcums__option"
                @click="$router.push({name: 'massive_whatsapp'})"
              >
                Historial de mensajes
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                class="breadcums__option"
                disabled
              >
                Nuevo mensaje
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <button
              type="button"
              class="faccess_button px-5"
              @click="sendMessage()"
              :disabled="!valid || message.attributes.title == '' || message.attributes.message == '' || excelTitle.length < 1"
            >
              Enviar
            </button>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
              <v-layout
                row
                wrap
                style="background-color: #fff; padding: 0px;">
                <v-flex
                  xs6
                  style="padding: 20px">
                  <v-text-field
                    v-model="message.attributes.title"
                    label="Título"
                    required
                    placeholder="Máximo 200 caracteres"
                    :rules="[rules.required, rules.title]"
                    counter="200"></v-text-field>
                </v-flex>
                <v-flex
                  xs6
                  style="padding: 8px">

                    <span class="table_card__info--label">Plantilla</span>
                    <v-select
                      label="Selecciona una plantilla"
                      v-bind:items="templates"
                      :item-text="'name'"
                      return-object
                      single-line
                      bottom
                      color="#1476FB"

                      solo
                      @change="changedTemplate"
                    ></v-select>

                </v-flex>

              </v-layout>

              <v-layout row wrap>
                <v-flex xs6>
                  <div :style="excelTitle.length<=0?'':''">
                    <!-- Fotos de la oferta -->
                    <span class="table_card__info--label">Adjuntar información (Formato Excel)</span>
                    <div class="trainers__form--photo_container" style="width:max-content">
                      <label
                        for="excel_input"
                        class="faccess_button buttom_shadow px-5">Examinar</label>
                      <input
                        id="excel_input"
                        type="file"
                        @change="excelUpload()"
                        name="logo"
                        :disabled="message.attributes.template_id == ''"
                        multiple>
                        <p class="accessIndex__text--small" style="margin-left:10%" v-if="excelTitle.length<=0" >Debe adjuntar un archivo con formato Excel</p>
                      </div>
                    </div>
                  <v-flex>
                      <div v-if="excelTitle.length!=0">
                        <p class="data_card__info--label">Nombre del archivo </p>
                        <p style="font-size: 10px;" ><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{excelTitle}}</p>
                      </div>
                  </v-flex>
                </v-flex>

                <v-flex xs6>
                    <v-textarea
                      v-model="message_template"
                      label="Mensaje"
                      required
                      v-if="message_template"
                      readonly
                      counter="900"></v-textarea>
                </v-flex>

              </v-layout>

                <v-layout row wrap>

                <v-flex  xs12>
                  <div v-if="tableData.length>0" style="margin-top: 30px;">

                    <v-data-table
                      :headers="headers"
                      :items="tableData"
                      hide-actions
                      class="elevation-1"
                    >
                    <template slot="items" slot-scope="props" >
                      <tr  class="importers__user_row">
                        <td v-for="data in Object.entries(props.item)" style="cursor: pointer" class="importers__user_data">
                          <input v-model="data[1]" :placeholder="data[0]" class="importers__input_data">
                        </td>
                      </tr>
                    </template>
                  </v-data-table>

                  </div>
                </v-flex>
              </v-layout>

            </v-form>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          type="button"
          class="faccess_button px-5"
          @click="sendMessage()"
          :disabled="!valid || message.attributes.title == '' || message.attributes.message == '' || excelTitle.length < 1"
        >
          Enviar
        </button>
      </div>
    </div>


  </div>

</template>

<script>
export default {
  data(){
    return{
      templates:[],
      variables: [],
      message_template: '',
      selected: 'Todos los usuarios',
      message_selector: ['Todos los usuarios', 'Varios usuarios'],
      message: {
        attributes: {
          title: '',
          message: '',
          users: [],
          send_date_time: '',
          gmt: '',
          company_id: 0,
          template_id:''
        }
      },
      search: '',
      date: null,
      time: null,
      modal: false,
      modal2: false,
      modal3: false,
      users: [],
      users_for_select:[],
      excelTitle: '',
      tableData: [],
      messageData: [],
      headers: [],
      rules: {
        required: value => !!value || 'Required.',
        title: value => value.length <= 200 || 'Maximo 45 caracteres',
        message: value => value.length <= 900 || 'Maximo 900 caracteres',
      },
      valid: false
    }
  },
  mounted() {
    this.getTemplates()
    this.message.attributes.company_id = this.getCompany().id
  },
  computed: {
  },
  methods: {

    changedTemplate(event){
      this.message.attributes.template_id = event.id
      this.message.attributes.message = event.message
      this.message_template = event.message
    },


    getTemplates(){
        try {
          this.$http.get('push_messages_templates/get_templates',{
            headers:{
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }
          })
          .then(function(response){
            this.templates = response.body.data
            console.log('this.Templates', this.templates)
            // cl Templates
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      },
    excelUpload(){
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if(fileUpload.files.length > 0){
        if (regex.test(fileUpload.value.toLowerCase())) {
          this.tableData = []
          var vm=this;
          if (typeof (FileReader) != "undefined") {
            var reader = new FileReader();
            vm.excelTitle=fileUpload.files[0].name;
            //For Browsers other than IE.
            if (reader.readAsBinaryString) {
              reader.onload = function (e) {
                  vm.usersJson={};
                  vm.ProcessExcel(e.target.result);
              };
              reader.readAsBinaryString(fileUpload.files[0]);
            } else {
              //For IE Browser.
              reader.onload = function (e) {
                  var data = "";
                  var bytes = new Uint8Array(e.target.result);
                  for (var i = 0; i < bytes.byteLength; i++) {
                      data += String.fromCharCode(bytes[i]);
                  }
                  vm.ProcessExcel(data);
              };
              reader.readAsArrayBuffer(fileUpload.files[0]);
            }
          } else {
            alert("Este navegador no soporta HTML5");
          }
        } else {
          alert("Por favor subir un archivo de códigos válido (Formato Excel)");
        }
      }
    },
    ProcessExcel(data) {
        // Leer los datos del archivo Excel.
        var workbook = XLSX.read(data, { type: 'binary' });

        // Obtener el nombre de la primera hoja.
        var firstSheet = workbook.SheetNames[0];

        // Convertir la hoja de trabajo en un objeto JSON.
        var excelRowsJson = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], { header: 1 });

        // Verificar que haya al menos una fila de datos.
        if (excelRowsJson.length > 0) {
          // Los encabezados están en la fila 0.
          var headers = excelRowsJson[0];

          // Los datos comienzan desde la fila 1.
          for (var i = 1; i < excelRowsJson.length; i++) {
            var rowData = excelRowsJson[i];

            // Verificar si la fila contiene datos antes de agregarla.
            if (rowData.some(cell => cell !== null && cell !== '')) {
              var dataObject = {};

              // Construir el objeto JSON para la fila actual.
              for (var j = 0; j < headers.length; j++) {
                var header = headers[j];
                dataObject[header] = rowData[j];
              }

              // Agregar el objeto a this.tableData solo si contiene datos.
              this.tableData.push(dataObject);
            }
          }

          // Agregar headers para la tabla
          for (var x = 0; x < headers.length; x++) {
                var data = {
                  text: headers[x],
                  align: 'left',
                  sortable: false,
                  value: headers[x]
                }

                this.headers.push(data);
                this.variables.push(headers[x])
          }
          // Invocar metodo para construir el mensaje
          this.buildMessageData();
        } else {
          console.log('El archivo Excel no contiene datos.');
        }
      },


  buildMessageData(){

    var messageTemplate = this.message.attributes.message

    this.tableData.forEach(data => {
      console.log('data', data)

      var message_data = {};
      this.message.attributes.users.push(data.Celular)

      message_data['message_content'] = messageTemplate;

      this.variables.forEach(item => {
        var word = item
        if (message_data['message_content'].includes(`#${word}#`)) {
          message_data['message_content'] = message_data['message_content'].replaceAll(`#${word}#`,`${data[word]}`)
        }
    })

      message_data['mobile'] = data['Celular'].toString()

      if (data['Link'] ){
        message_data['link'] = data['Link'].toString()
      }

      this.messageData.push(message_data);

    })

    console.log('-------------> this.messageData', this.messageData)
    },


    sendMessage(){
      var data = { message_info: this.message, receivers: this.messageData }

      try {
        this.$http.post('push_messages/send_massive_whatsapp_messages',{
          data: this.encrypt(data).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);
          this.$router.push({name: 'massive_whatsapp'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        alert(e.message)
      }
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/whatsapp/new_message.vue